import { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

export const AgeGate: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShow(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShow(false);
  };

  const handleReject = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm">
      <div className="glass-card p-8 max-w-md mx-4 text-center">
        <h2 className="text-3xl font-bold text-primary-green mb-4">
          18+ Age Verification Required
        </h2>
        <p className="text-gray-300 mb-6">
          You must be 18 or older to access this website. By continuing, you confirm that you are of legal gambling age in the United Kingdom.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={handleReject}
            className="btn-secondary"
          >
            I'm Under 18
          </button>
          <button
            onClick={handleConfirm}
            className="btn-primary"
          >
            I'm 18 or Older
          </button>
        </div>
      </div>
    </div>
  );
};

